// Next.js API route support: https://nextjs.org/docs/api-routes/introduction
import http from "../../http";

// 设置默认平台
export function getChainData(uuid: string): Promise<{
  code: number;
  message: string;
  data: any[];
  status: boolean;
}> {
  return http.get(`/api/v1/chat/chain?history_id=${uuid}`);
}

// 获取项目目录
export const getRepoMenu = (params: {
  thread_id: string;
  repo_full_name: string;
  branch_name: string;
  type: string;
  file_path: string;
}): Promise<any> => {
  return http.post(`/api/v1/chat/code-folder`, params);
};

// 获取代码内容
export const getCodeContent = (params: {
  thread_id: string;
  repo_full_name: string;
  branch_name: string;
  type: string;
  file_path: string;
}): Promise<any> => {
  return http.post(`/api/v1/chat/code-content`, params);
};

export const getGitBranch = (params: {
  url: string;
  type: string;
}): Promise<any> => {
  if (params.url.includes("/tree/")) {
    return new Promise((resolve, reject) => {
      let match = params.url.match(
        /^https:\/\/github\.com\/([^\/]+)\/([^\/]+)\/tree\/(.+)$/
      );
      if (params.type === "gitee") {
        match = params.url.match(
          /^https:\/\/gitee\.com\/([^\/]+)\/([^\/]+)\/tree\/(.+)$/
        );
      }

      if (match) {
        const repo_full_name = `${match[1]}/${match[2]}`;
        const branch_name = match[3];
        resolve({
          message: "success",
          status: true,
          code: 200,
          data: {
            url: params.url,
            type: params.type,
            branch_name: decodeURIComponent(branch_name),
            repo_full_name: repo_full_name,
          },
        });
      } else {
        reject({
          message: "url不合规",
          status: false,
          code: 400,
          data: null,
        });
      }
    });
  } else {
    return http.post(`/api/v1/chat/repo/branch`, params);
  }
};
